import { useState } from "react";
import classNames from "classnames";

import { getActivationStatusLabel } from "../../Constants";

const activationStatusTypes = [
  {
    title: "none",
    status: "none",
    value: 0,
  },
  {
    title: "requested",
    status: "requested",
    value: 1,
  },

  {
    title: "active",
    status: "active",
    value: 3,
  },
  {
    title: "revoked",
    status: "revoked",
    value: 5,
  },
];

export default function ActivationStatusButton({ value, language, updateUserDraft }) {
  const [isHovered, setIsHovered] = useState(false);

  const currentStatus = activationStatusTypes.find((item) => item.value === value);

  const status = currentStatus?.status;

  const buttonClass = classNames({
    requested: status === "requested" && !isHovered,
    accept: status === "requested" && isHovered,

    active: status === "active" && !isHovered,
    revoke: status === "active" && isHovered,

    revoked: status === "revoked" && !isHovered,
    restore: status === "revoked" && isHovered,
  });

  const handleClick = () => {
    let newStatus;

    if (status === "requested" || status === "revoked") {
      newStatus = 3;
    }

    if (status === "active") {
      newStatus = 5;
    }

    if (newStatus === undefined) return;

    updateUserDraft(newStatus);
  };

  const buttonTitle = getActivationStatusLabel(buttonClass || status, language);

  return (
    <button
      className={`request-button request-button--${buttonClass}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {buttonTitle}
    </button>
  );
}
